import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="pt-48 pb-40 md:pt-48 md:pb-48">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        {/* 404 Header */}
        <h1 className="text-8xl md:text-9xl font-bold tracking-tight mb-4">
          <span className="bg-gradient-to-r from-primary to-[#E6C45C] text-transparent bg-clip-text">404</span>
        </h1>
        
        <h2 className="text-3xl md:text-4xl font-bold text-white mt-8 mb-6">
          Page Not Found
        </h2>

        <p className="text-[#FFFFFFCC] text-lg md:text-xl max-w-2xl mx-auto mb-12">
          We couldn't find the page you're looking for. It might have been moved, deleted, or never existed.
        </p>

        {/* Back to Home Button */}
        <Link
          to="/"
          onClick={() => window.scrollTo(0, 0)}
          className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-xl bg-gradient-to-r from-primary to-[#E6C45C] text-[#0A0A0A] hover:opacity-90 transition-all duration-300 shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] group"
        >
          <span>Return Home</span>
          <svg 
            className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </Link>

        {/* Decorative Elements */}
        <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-primary/[0.03] rounded-full blur-3xl -z-10 animate-pulse" style={{ animationDuration: '10s' }} />
        <div className="absolute bottom-1/3 left-1/4 w-64 h-64 bg-primary/[0.03] rounded-full blur-3xl -z-10 animate-pulse" style={{ animationDuration: '15s' }} />
      </div>
    </div>
  );
};

export default NotFound; 